import QueryService from "services/QueryService";
import WidgetTagsConfigureDialog from "components/widget/widget-configure-dialogs/widget-tags-configure-dialog/WidgetTagsConfigureDialog";
const ISO_DAYS_OF_WEEK = ["MO", "TU", "WE", "TH", "FR", "SA", "SU"];

//pending:
//options.start: timestamp of start of data range
//options.end: timestamp of end of data range
//options.include-errtok: flag to include errtok values (defaults to false)
//options.include-header: flag to include header in csv
//options.one-file: flag to combine all tags to a single file

function createRequest(opts) {
    const getslots = (prs) => {
        return prs.map((p) => {
            const cp = p?.tunits[0];
            const weekbitmap = (cp?.byweekday ?? [])
                .map((d) => Math.pow(2, ISO_DAYS_OF_WEEK.indexOf(d)))
                .reduce((a, b) => a + b, 0);
            //console.log("cp and weekbitmap",cp?.byweekday,weekbitmap);
            return `${weekbitmap}_${cp?.start ?? 0}_${(cp?.start ?? 0) + (cp?.["duration.value"] ?? 24) * 3600000
            }`;
        });
    };
    // !! be sure to add new Export Report options here!!
    const options = ["acu_groups","beginat","data-format","email","email-tables",
        "forwardamount","forwardunit","fname","frequency-type","include-header",
        "lookbackamount","lookbackunit","note","one-file","periodids","periods",
        "recur","selected-days","selected-hour","selected-minute","sort-alpha","startofweek","summaryoptions","timerange","timezone"
    ].reduce((o,a)=>{o[a]=opts.options?.[a]; return o}, {});
    options["emailattachment"] = opts.options?.["emailattachment"] ? "csv" : false;
        options.slots = getslots(opts.options?.periods || "");
    if (options.summaryoptions == undefined)
        { 
            options.summaryoptions = Object.fromEntries(Object.values(opts.options["periods.tracking"] ?? {}).map((x) => [x.key, x]));
    }
    console.log("slots and timezone are", options,opts);
    /*if (options?.timeframe?.type === "moving") {
    options.start = new Date().setHours(0, 0, 0, 0);
    options.end = options.start + (options?.timeframe?.['length.value'] * timelengthmap[options?.timeframe?.['length.units']]*86400000)
    options["recur-days"] = timelengthmap[options?.timeframe?.['length.units']]
    }
    else {
    if (options?.timeframe?.start) {
    options.start = convertDT(options?.timeframe?.start);
    options.end = convertDT(options?.timeframe?.end);
    }
    }*/
    if (options["time-sensitivity"]) {
            options["time-sensitivity"] = parseInt(options["time-sensitivity"]) || 0;
    }
    if (options?.recur === "0") {
        options.start = opts.options?.fixedstart ?? opts.options?.start
        options.end = opts.options?.fixedend ?? opts.options?.end
    }
    else {
        options.start = opts.options?.recurstart ?? opts.options?.start
        options.end = opts.options?.recurend ?? opts.options?.start
        options["execute-after"] = opts.options?.["execute-after"]
        options["recur-days"] = opts.options?.["recur-days"]
    }
    console.log("report options are",options);
    return {
        tags: opts.tags.map((t) => t.stack + "_" + t.attribute),
        options: options,
    };
}

//local props (many others are passed along to children)
// reportOptions (function that makes a "fake widget" to edit)
// setReportOptions (callback when options are set - used for exports widget)
// createWhenDown (used to just create a request when finished - used for widget ... menu)
function SetupReportDialog(props) {
    const createWhenDone = !!props.createWhenDone;
    //fake widget of the form { tags: [{guuid:, stack:, attribute:}...], options: {export options} }
    const fakeWidget = props.reportOptions && props.reportOptions() || {tags:[], options:{}};
    
    // this is a way to re-use the underlying config components.
    // this function usually would update a widget, but instead we just update
    // the config options
    function updateFakeWidget(opts) {
        const options = createRequest(opts);
        if(props.setReportOptions) {
            props.setReportOptions(options);
        }
        if(props.createWhenDone) {
            QueryService.putExport(options);
        }
    }
    return (
        <WidgetTagsConfigureDialog
            {...props}
            startAtStep={ (!props.dontSkipTagsPage && fakeWidget?.tags?.length) ? 1 : 0 }
            widget={fakeWidget}
            updateWidget={updateFakeWidget}
            open= {true}
            dialogText={"Select the stack and tags from which you would like to export data. Note that export requests are processed as compute is available; They will not appear immediately."}
            options={[
                {
                    type: "export",
                    default: {
                        //"include-header": true,
                        //"sort-alpha":true,
                        "emailattachment": false,
                        //"one-file":true,
                        "data-format": "1",
                        "beginat": "0",
                        "frequency-type": "daily"
                    }
                },
                {
                    type: "timezone"
                },
                {
                    type: "timeframerecur",
                    default: {
                        hide_type_toggle: true,
                        "recur": "0",
                        "timerange": "day",
                        "startofweek": "MO"
                    },
                },
                {
                    type: "periods",
                    includeStacks: true,
                    default: {
                        periods: [],
                        periods_to_show: 1,
                        hide_num_periods: true,
                        ignore_period_match: true,
                    },
                },
                { type: "exportpreview", },
                {
                    type: "periodreporting",
                    includeStacks: true,
                    default: {
                        "periods.tracking": "counts",
                        statereporting: {
                            states: [
                                {
                                    id: 1,
                                    label: "Off",
                                    lowerBound: "0",
                                    upperBound: "15",
                                    minDuration: "5",
                                    color: "",
                                },
                                {
                                    id: 2,
                                    label: "On",
                                    lowerBound: "10",
                                    upperBound: "100",
                                    minDuration: "10",
                                    color: "",
                                },
                            ],
                        },
                    },
                }
            ]}
        />);
}

export default SetupReportDialog;
